//获取数据
export default {
    token:state => {
		  return state.token
   },
   userInfo:state => {
   		 return state.userInfo
   },
}